import React from 'react';
import styled from 'styled-components';

import media from '../../style/mediainjector';
import { Container, Section } from '../Blocks';

const PresentazioneWrapper = styled.div`
  h2 {
    color: ${(props) => props.theme.brand};
    text-align: center;
    font-size: 2em;
  }
  h3 {
    position: relative;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    height: 60px;
    color: ${(props) => props.theme.brand};
    margin: 0px;
    padding: 0px;
    font-size: 2rem;
  }`;

const TableWrapper = styled.div`
  h2 {
    color: ${(props) => props.theme.brand};
    text-align: center;
    margin-top: 60px;
  }
  table {
    width: 100%;
    border-collapse:collapse;
    border-spacing:0;
    margin: 0 auto;
    text-align: center;
    border: none;
    tr {
      border-bottom: 1px solid #999;
      ${media.lt667`
        border-bottom: none;
      `}
      &:last-child {
        border-bottom: none;
      }
      td,
      th {
        padding: 15px;
        ${media.lt667`
          padding: 15px 10px;
        `}
      }
      th {
        background: rgba(0,0,0,0.05);
      }
    }

    td {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    ${media.lt667`
      font-size: 1.2rem;
      thead, tbody, th, td, tr {
        display: block;
      `}
      tbody {
        border-bottom: 1px solid #000;
      }
      thead {
        border-bottom: 0;
        tr {
          position: absolute;
          top: -9999px;
          left: -9999px;
        }
      }
      th {
        font-weight: bold;
        font-size: 1.2em;
        border-bottom: 1px solid #d2d2d2;
        br {
          display: none;
        }
      }

      td {
        border: none;
        border-bottom: 1px solid #d2d2d2;
        position: relative;
        text-align: left;
        padding-left: 70px !important; // TOFIX diosanto
      }

      td:before {
        position: absolute;
        top: 0px;
        left: 0px;
        bottom: 0px;
        width: 60px;
        padding-left: 10px;
        white-space: nowrap;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: rgba(0,0,0,0.05);
      }
      /*
    Label the data
    */
    /* td:nth-of-type(1):before { display:none } */
    td:nth-of-type(1):before { content: "ISBN"; font-weight: 600; }
    td:nth-of-type(2):before { content: "Durata"; font-weight: 600; }
    td:nth-of-type(3):before { content: "Prezzo"; font-weight: 600; }
    td:nth-of-type(4):before { content: "Offerta"; font-weight: 600; }
    }
    .descrizione,
    .legenda {
      font-weight: 400;
      font-size: 1.3rem;
    }
    .legenda {
      padding: 10px !important; // TOFIX diosant
      ${media.lt667`
        font-size: 1rem;
        &:before {
          position: absolute;
          top: 0px;
          left: 0px;
          bottom: 0px;
          width: 0;
          content: " " !important;
          background: none;
        }
      `}
    }
  }
  ${media.print`
      h1,
      h2,
      h3,
      h4 {
        color: black;
      }
    `}
`;


function PageCorso({ corsoPrezzi, corsoPresentazione }) {
  return (
    <Section
      first
    >
      <Container>
        <PresentazioneWrapper dangerouslySetInnerHTML={{ __html: corsoPresentazione }} />
        <TableWrapper dangerouslySetInnerHTML={{ __html: corsoPrezzi }} />
      </Container>
    </Section>
  );
}

export default PageCorso;
